import { OrderEntity } from 'api/types/entity';

import { useSignOrder } from '../../hooks/useSignOrder';

import { DialogSignOrderForm } from './DialogSignOrderForm';

export interface DialogSignOrderFeatureProps {
  order: OrderEntity;
  isOpen: boolean;
  startDate?: Date;
  executionPeriodInBusinessDays?: number;
  onClose: () => void;
}

export const DialogSignOrderFeature = ({
  order,
  isOpen,
  executionPeriodInBusinessDays,
  startDate,
  onClose,
}: DialogSignOrderFeatureProps) => {
  const { signFormError, onSign } = useSignOrder({
    order,
    startDate,
    executionPeriodInBusinessDays,
  });

  return (
    <DialogSignOrderForm
      formError={signFormError}
      isOpen={isOpen}
      orderType={order.operationType}
      onClose={onClose}
      onSign={onSign}
    />
  );
};
